<template>
  <view class="speech-recognition-top">
    <soundWave
      :showChat="false"
      style="width: 0px; margin: 0 auto"
      ref="soundWave"
      :max="0"
      @started="recordStarted"
      @process="recordProcess"
      @localProcess="localProcess"
      @chunk="recordChunk"
      @speechEnd="speechEnd"
      @stoped="recordStoped"
      @end="recordEnd"
    >
    </soundWave>
  </view>
</template>

<script>
import soundWave from "@/views/AiChat/components/soundWave.vue";
import { pinyin } from "pinyin-pro";

export default {
  components: { soundWave },
  props: {
    listen: {
      type: Boolean,
      default: true,
    },
    showText: {
      type: Boolean,
      default: true,
    },
    wakeUpKeywords: {
      type: Array,
      default: () => {
        // 唤醒词 小科小科  叫小科的时候不要醒
        return ["xiaokexiaoke", ["xiaokexiaoke"], ["xiaokexiao", "ke"]];
      },
    },
    closeKeywords: {
      type: Array,
      default: () => {
        return ["停止", "退出", "退下", "关闭", "再见"];
      },
    },
  },
  data() {
    return {
      isCalledMyName: false,
      isInitSpeechRecognitionAssistant: false, // 是否初始化了语音播放
      value: "",
      wakeUpWaitingTimer: null,
      retryTimer: null,
      retryCount: 0, // 重试次数
      aiChatlang: "",
      audioObj: {
        APPID: "YOUR_APPID",
        API_KEY: "YOUR_API_KEY",
        API_SECRET: "YOUR_API_SECRET",
        hasClick: false,
        isShowRecordPanel: false,
        isRecording: false,
        audio: null,
        tempResult: "",
        audioToTextResult: "",
        statusText: "",
      },
    };
  },
  computed: {
    isWakeUp() {
      return this.$store.state.aiChat.isWakeUp;
    },
  },
  mounted() {
    if (this.listen) {
      this.getAudioStream().then(() => {
        this.init();
        document.addEventListener(
          "visibilitychange",
          this.handleVisibilityChange
        );
      });
    }
  },
  beforeDestroy() {
    this.stop();
    document.removeEventListener(
      "visibilitychange",
      this.handleVisibilityChange
    );
  },
  methods: {
    handleVisibilityChange() {
      if (document.visibilityState === "visible") {
        this.init();
      } else {
        this.stop();
      }
    },
    getAudioStream() {
      return new Promise((resolve, reject) => {
        navigator.mediaDevices
          .getUserMedia({ audio: true })
          .then((stream) => {
            console.log("有录音权限");
            resolve(stream);
          })
          .catch((err) => {
            console.log("没有录音权限");
            alert("没有录音权限");
          });
      });
    },
    speak(str) {
      return this.$parent.speak(str);
    },

    isWakeUpKeyword(str) {
      str = pinyin(str, { toneType: "none", separator: "" });
      for (var i = 0; i < this.wakeUpKeywords.length; i++) {
        let wakeUpKeyword = this.wakeUpKeywords[i];
        if (typeof wakeUpKeyword === "string") {
          if (
            str
              .toLocaleUpperCase()
              .indexOf(wakeUpKeyword.toLocaleUpperCase()) != -1
          ) {
            return true;
          }
        } else if (Array.isArray(wakeUpKeyword)) {
          let isAllMatch = true;
          for (var j = 0; j < wakeUpKeyword.length; j++) {
            let item = wakeUpKeyword[j];
            if (
              str.toLocaleUpperCase().indexOf(item.toLocaleUpperCase()) == -1
            ) {
              isAllMatch = false;
              break;
            }
          }
          if (isAllMatch) {
            return true;
          }
        }
      }
      return false;
    },
    init() {
      if (this.$refs.soundWave) {
        this.$refs.soundWave.recStart();
        this.connectWebSocket();
      }
    },
    async stop() {
      this.$refs.soundWave.recStop();
      this.audioObj.isRecording = false;
      this.audioObj.audioToTextResult = "";
      this.audioObj.tempResult = "";
    },
    retry() {
      this.retryTimer && clearTimeout(this.retryTimer);
      this.retryTimer = setTimeout(() => {
        if (this.retryCount <= 5) {
          this.restart();
        }
        this.retryCount++;
      }, 2000);
    },
    async restart() {
      await this.stop();
      this.init();
    },
    connectWebSocket() {
      console.log("connectWebSocket");
      let self = this;
      // const websocketUrl = "ws://10.0.108.100:20003/ws/translate/";
      const websocketUrl = window._CONFIG.AI_SPEECH_URL;
      if ("WebSocket" in window) {
        this.websocketInstance = new WebSocket(websocketUrl);
      } else {
        alert("浏览器不支持WebSocket");
        return;
      }

      this.websocketInstance.onopen = (e) => {
        var chunk_size = new Array(5, 10, 5);
        var request = {
          chunk_size: chunk_size,
          wav_name: "h5",
          is_speaking: true,
          chunk_interval: 10,
          mode: "2pass",
          wav_name: "h5",
        };
        this.websocketInstance.send(JSON.stringify(request));
        self.audioObj.isRecording = true;
      };

      this.websocketInstance.onmessage = (e) => {
        // console.log("websocketInstance.onmessage:", e);
        self.renderResult(e.data);
      };

      this.websocketInstance.onerror = (e) => {
        console.log("websocketInstance.onerror:", e);
        self.retry();
      };

      this.websocketInstance.onclose = (e) => {
        console.log("websocketInstance.onclose:", e);
      };
    },
    renderResult(resultData) {
      let self = this;
      let jsonData = JSON.parse(resultData);

      // let flag = jsonData.timestamp && jsonData.timestamp.length > 0;
      // console.log("语音转文字结果:", jsonData.text, jsonData.is_final, flag);

      console.log("本地Whisper语音转文字结果----:", jsonData.text);

      if (jsonData.text) {
        let str = jsonData.text;

        // console.log("退下没有？", self.isCloseKeyword(str));
        if (self.isWakeUp && self.isCloseKeyword(str)) {
          self.$store.commit("setIsWakeUp", false);
        } else if (self.isWakeUpKeyword(str) && !self.isCalledMyName) {
          self.wakeUp(str);
          return;
        }
        self.audioObj.tempResult += str;
      }
    },
    wakeUp() {
      this.wakeUpWaitingTimer && clearTimeout(this.wakeUpWaitingTimer);
      this.isCalledMyName = true;
      this.$store.commit("setIsWakeUp", true);
      this.$store.commit("setWakeUpChatList");
      let str = "我在";
      if (this.aiChatlang === "en") {
        str = "I'm here";
      }
      this.speak(str);
      // 1秒后再把状态给关闭 ，防止一句话唤醒2次
      setTimeout(() => {
        this.isCalledMyName = false;
      }, 1500);
      this.$emit("wakeUp");
    },
    isCloseKeyword(str) {
      // 关闭词必须 <= 3
      if (str.length > 3) {
        return false;
      }
      for (var i = 0; i < this.closeKeywords.length; i++) {
        let keywords = this.closeKeywords[i];
        if (typeof keywords === "string") {
          if (str.indexOf(keywords) !== -1) {
            return true;
          }
        } else if (Array.isArray(keywords)) {
          let isAllMatch = true;
          for (var j = 0; j < keywords.length; j++) {
            let item = keywords[j];
            if (str.indexOf(item) == -1) {
              isAllMatch = false;
              break;
            }
          }
          if (isAllMatch) {
            return true;
          }
        }
      }
      return false;
    },

    recordStarted() {
      console.log("listen-whisper.vue----recordStarted");
    },

    recordStoped(audio) {
      console.log("listen-whisper.vue----recordStoped", audio);
      this.audioObj.audio = audio;
    },

    recordEnd() {
      console.log("listen-whisper.vue----recordEnd");
    },

    bufferToBase64(buffer) {
      let binary = "";
      const bytes = new Uint8Array(buffer);
      for (let i = 0; i < bytes.byteLength; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      return window.btoa(binary);
    },
    recordProcess(chunk, powerLevel, duration, sampleRate, newBuffers) {
      // console.log("22222222222222", chunk, newBuffers[0])
      if (powerLevel > 10) {
        // this.learningNoVoiceClose(null, "录音中， powerLevel > 10");
      }
    },
    localProcess(buffer) {
      if (
        this.websocketInstance &&
        this.websocketInstance.readyState === WebSocket.OPEN &&
        this.audioObj.isRecording
      ) {
        this.websocketInstance.send(buffer);
      }
    },
    recordChunk(chunk) {
      if (
        this.websocketInstance &&
        this.websocketInstance.readyState === WebSocket.OPEN &&
        this.audioObj.isRecording
      ) {
        // console.log("chunk", chunk)
        // this.websocketInstance.send(chunk.buffer);
      }
    },

    speechEnd() {
      // console.log("speechEnd");
      // return
      // if (this.websocketInstance && this.websocketInstance.readyState === WebSocket.OPEN && this.audioObj.recordStatus === "LISTEN") {
      // 	const params = {
      // 		"header": {
      // 			"status": 2,
      // 			"app_id": this.audioObj.APPID
      // 		},
      // 		"payload": {
      // 			"audio": {
      // 				"encoding": "raw",
      // 				"sample_rate": 16000,
      // 				"audio": ""
      // 			}
      // 		}
      // 	};
      // 	this.websocketInstance.send(JSON.stringify(params));
      // 	this.audioObj.recordStatus = "STOP";
      // 	this.learningNoVoiceClose(1500, "specchEnd 本次说话结束");
      // }
    },
  },
};
</script>

<style lang="less" scoped></style>
